'use client';

import Breadcrumbs from '@sympla/sympla-components/Breadcrumbs';
import CategoriesContent from 'components/CategoriesContent/CategoriesContent';
import { CategoriesContainer, CategoriesContainerWrapper } from 'components/Container/Container.css';
import { breadcrumbCategories } from 'constants/breadcrumbCategories';
import { SearchCollection } from 'searchCollection';

export type CategoriesTemplateProps = {
  collections: SearchCollection;
};

function CategoriesTemplate({
  collections,
}: CategoriesTemplateProps) {
  return (
    <div className={CategoriesContainerWrapper}>
      <div className={CategoriesContainer}>
        <Breadcrumbs list={breadcrumbCategories} />
        <CategoriesContent collections={collections} />
      </div>
    </div>
  );
}

export default CategoriesTemplate;
